import styled from 'styled-components';

const DoorShapes = styled.div`
  & svg {
    & .svg-shape-bg {
      fill: ${(props) => props.background};
    }
    
    & .svg-shape-stroke {
      stroke: ${(props) => props.border};
    }
  }
`;

export default DoorShapes;
